import { logEvent } from '../../lib/analytics';
import { redirectToOnboardingCheckout } from '../../lib/redirect';
import { useVoiceDemo } from '../../providers/VoiceDemoContext';
import { newStyles } from '../elements/StyleJigsaw';
import { DownloadIcon } from '../icons/Download';

export const DownloadAudio = () => {
  const { currentVoice, currentContent, currentStyle } = useVoiceDemo();
  return (
    <button
      onClick={(event) => {
        event.preventDefault();
        logEvent('download_interaction', {
          action: 'clicked',
        });
        const styleDetail = currentStyle
          ? newStyles.find((s) => s.style === currentStyle)
          : null;
        void redirectToOnboardingCheckout({
          voiceId: currentVoice.id,
          textContent: currentContent,
          prompt: styleDetail?.prompt,
        });
      }}
      className="flex h-12 flex-1 cursor-pointer items-center justify-center gap-2 rounded-[16px] border-[1px] border-[#E9EAF0] px-4 py-3 hover:bg-[#E9EAF0]">
      <DownloadIcon />
      <div>Download</div>
    </button>
  );
};
